import { constant } from 'constants/constant';
import React, { useEffect, useRef, useState } from 'react'
import LoadingBar from 'react-top-loading-bar'
import Tab from 'components/common/Tab';
import { EwayBill, EwayBillChecker } from '.';

const Ebill = () => {

    const loadingBarRef = useRef(null);
    const [ewayBillTab, setEwayBillTab] = useState(1);

    const tabProps = {
        tabList: constant.ewayBillTabs,
        callBackTab: (e) => setEwayBillTab(e),
        activeTab: ewayBillTab,
    };

    return (
        <>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />

            <div className="addPr_flBx __uiTx_new">
                <Tab {...tabProps} />
                {ewayBillTab === 1 && <EwayBill />}
                {ewayBillTab === 2 && <EwayBillChecker />}
            </div>
        </>
    )
}

export default Ebill